// frontend/src/pages/richcontentdisplay.js
import React, { useEffect } from 'react';
import { API_BASE, authFetch } from '../services/api.js';
import { renderBlock, groupBlocks } from './richcontenthelpers.js';
import './richcontentdisplay.css';

const RichContentDisplay = ({
  microChunkId,
  language,
  onBlocksLoaded,   // callback — passes blocks up to parent
}) => {

  // ── Fetch blocks when micro chunk changes ────────────────────────────────
  useEffect(() => {
    if (!microChunkId) {
      onBlocksLoaded([]);
      return;
    }
    fetchBlocks();
  }, [microChunkId, language]);

  const fetchBlocks = async () => {
    try {
      const response = await authFetch(
        `${API_BASE}/rich-content/micro-chunk/${microChunkId}?language=${language}`
      );
      if (response.ok) {
        const data = await response.json();

        // ── Hindi fallback — if no Hindi blocks exist, load English ──────
        if (data.length === 0 && language === 'hi') {
          const fallback = await authFetch(
            `${API_BASE}/rich-content/micro-chunk/${microChunkId}?language=en`
          );
          if (fallback.ok) {
            const fallbackData = await fallback.json();
            onBlocksLoaded(fallbackData);
            return;
          }
        }

        onBlocksLoaded(data);
      } else {
        onBlocksLoaded([]);
      }
    } catch (err) {
      console.error('Error fetching rich content:', err);
      onBlocksLoaded([]);
    }
  };
  
  return null; // rendering is handled by parent
};

export default RichContentDisplay;